



import {Component, Prop, Vue} from 'vue-property-decorator';
const HorizontalCord = () => import('@/components/Atoms/GrowTree/HorizontalCord/HorizontalCord.vue')

@Component({
  components: {HorizontalCord}
})
export default class HorizontalCordGroup extends Vue {
  @Prop({type: Number, default: 0}) total!: number
}
